import { useDevEnvironment } from '@/composables/useDevEnvironment'

/**
 * Erkennt den Instanz-Typ anhand des Instanz-Namens. Einheitlicher Eintrittspunkt
 * für das namensbasierte Feature-Gating (Demo, Präsentation, Projekt-Instanz) plus
 * die Dev-Umgebung (delegiert an `useDevEnvironment`).
 *
 * Quelle für die Namens-Checks ist `localStorage 'domain'` (= Backend
 * `ALLOWED_HOSTS[0]`, enthält den `CONSTANTS_DB` der Instanz).
 *
 * - Demo-Instanz: `-demo` gefolgt von einer Ziffer, auf einer `.asix.pro`-Domain
 *   (z.B. `kunde-demo1.asix.pro`)
 * - Präsentations-Instanz: enthält `-presentation`, auf einer `.asix.pro`-Domain
 * - Projekt-Instanz: Name beginnt mit `projekt-<zahl>-` (z.B. `projekt-12893-...`)
 * - Master-Test-Instanz: enthält `master-test`, auf einer `.asix.pro`-Domain
 *   (z.B. `systent-master-test.asix.pro`) — Ziel für den manuellen Sync-Testlauf
 * - Dev-Instanz: DevStack/localhost (siehe `useDevEnvironment`)
 *
 * Die `.asix.pro`-Bindung verhindert, dass ein fremder/gespoofter Host die
 * Demo-/Präsentations-Erkennung über einen zufälligen Teilstring auslöst.
 *
 * Verwende dieses Composable statt direkter `localStorage`-Checks, damit das
 * Feature-Gating konsistent bleibt.
 */
export function useInstanzErkennung() {
  const domain = localStorage.getItem('domain') ?? ''
  const isDemoInstanz = /-demo[0-9].*\.asix\.pro$/.test(domain)
  const isPresentationInstanz = /-presentation.*\.asix\.pro$/.test(domain)
  const isProjektInstanz = /^projekt-\d+-/.test(domain)
  const isMasterTestInstanz = /master-test.*\.asix\.pro$/.test(domain)
  const { isDevEnvironment } = useDevEnvironment()
  return {
    isDemoInstanz,
    isPresentationInstanz,
    isProjektInstanz,
    isMasterTestInstanz,
    isDevInstanz: isDevEnvironment,
    isDemoOrPresentationInstanz: isDemoInstanz || isPresentationInstanz,
  }
}
